/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechPcLaptopIcon20Solid = forwardRef('TechPcLaptopIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M5 2a3 3 0 0 0-3 3v5a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3H5Z" }),
        React.createElement("path", { d: "M3.112 14.485a.75.75 0 1 0-1.145-.97L.821 14.87c-.963 1.138-.154 2.881 1.336 2.881h15.686c1.49 0 2.299-1.743 1.336-2.88l-1.146-1.355a.75.75 0 0 0-1.145.97l1.146 1.354a.25.25 0 0 1-.19.411H2.156a.25.25 0 0 1-.191-.412l1.146-1.353Z" })));
});
